import type { GetAppIntegrationUsersParams } from "./type";

export const appIntegrationKey = {
  all: (id: string) => ["app-integrations", id] as const,
  rule: (id: string) => [...appIntegrationKey.all(id), "rules"] as const,
  setting: (id: string) => [...appIntegrationKey.all(id), "settings"] as const,
  // TODO: integratableApp(appのmarketplaceから連携可能なアプリ)はこのオブジェクトでの管理は不適切なので移動する
  integratableApp: (appId: string) => ["integratable-app", { appId }] as const,
  countByCategories: (id: string) =>
    [...appIntegrationKey.all(id), "count-by-categories"] as const,
  users: (id: string) => [...appIntegrationKey.all(id), "users"] as const,
  usersSearch: (id: string, search: GetAppIntegrationUsersParams) =>
    [...appIntegrationKey.users(id), "search", { search }] as const,

  contract: (id: string) => [...appIntegrationKey.all(id), "contract"] as const,
  overviewUser: (id: string) =>
    [...appIntegrationKey.all(id), "overview/user-and-people"] as const,
  overviewBillingCost: (id: string) =>
    [...appIntegrationKey.all(id), "overview/billing-cost"] as const,
  overviewUserGrowth: (id: string) =>
    [...appIntegrationKey.all(id), "overview/user-growth"] as const,
  overviewMonthlyActiveUserRate: (id: string) =>
    [
      ...appIntegrationKey.all(id),
      "overview/monthly-active-user-rate",
    ] as const,
  overviewMonthlyCost: (id: string) =>
    [...appIntegrationKey.all(id), "overview/monthly-cost"] as const,
  overviewRenewalDate: (id: string) =>
    [...appIntegrationKey.all(id), "overview/renewal-date"] as const,
  overviewSavingCost: (id: string) =>
    [...appIntegrationKey.all(id), "overview/saving-cost"] as const,
  overviewRecommendedActions: (id: string) =>
    [...appIntegrationKey.all(id), "overview/recommended-actions"] as const,

  // refresh status
  refreshStatus: (id: string) =>
    [...appIntegrationKey.all(id), "refresh-status"] as const,

  // MDM configuration
  mdmConfiguration: (id: string) =>
    [...appIntegrationKey.all(id), "mdm-configuration"] as const,

  // Software data
  software: (id: string) => [...appIntegrationKey.all(id), "software"] as const,
} as const;
